import { Form } from "react-bootstrap";
import "../style/style-register.css";
import { useState } from "react";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import ProtectedRoute from "../components/ProtectedRoute";

export default function ModifierPassword() {
  const token = Cookies.get("auth_token");

  const [password, setPassword] = useState("");
  const [nouvelPassword, setNouvelPassword] = useState("");
  const [confirmeNouvelPassword, setConfirmeNouvelPassword] = useState("");
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [errorConfirm, setErrorConfirm] = useState(null);

  const modifierPassword = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("actuel_pass", password);
    form.append("new_pass", nouvelPassword);
    form.append("confirm_pass", confirmeNouvelPassword);

    axios
      .post("/modifierPassword", form, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setSuccess(response.data.success);
        setError(response.data.err);
        setErrorConfirm(response.data.err_confirm);
        Swal.close();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <ProtectedRoute>
      <div id="section" className="signup">
        <div className="container card">
          <div className="row bg-light">
            <div className="col-sm-12">
              <center>
                <h4 style={{ fontWeight: "900", padding: "10px" }}>
                  Modifier mot de passe
                </h4>
              </center>
            </div>
          </div>

          <div className="signup-content">
            <Form
              id="signup-form"
              className="signup-form"
              onSubmit={modifierPassword}
            >
              <div className="row">
                {success != null ? (
                  <div className="alert alert-success col-sm-12 text-center">
                    {" "}
                    {success}{" "}
                  </div>
                ) : null}

                <div className="form-group col-sm-12">
                  <input
                    type="password"
                    required
                    className="form-input"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError(null);
                    }}
                    placeholder="Actuel Mot de passe"
                  />
                  {error != null ? (
                    <span style={{ color: "red", fontSize: "15px" }}>
                      {error}
                    </span>
                  ) : null}
                </div>

                <div className="form-group col-sm-12">
                  <input
                    type="password"
                    required
                    className="form-input"
                    value={nouvelPassword}
                    onChange={(e) => {
                      setNouvelPassword(e.target.value);
                      setError(null);
                    }}
                    placeholder="Nouveau Mot de passe"
                  />
                </div>

                <div className="form-group col-sm-12">
                  <input
                    type="password"
                    required
                    className="form-input"
                    value={confirmeNouvelPassword}
                    onChange={(e) => {
                      setConfirmeNouvelPassword(e.target.value);
                      setError(null);
                    }}
                    placeholder="Confirmer le nouveau mot de passe"
                  />
                  {errorConfirm != null ? (
                    <span style={{ color: "red", fontSize: "15px" }}>
                      {errorConfirm}
                    </span>
                  ) : null}
                </div>

                <div className="form-group col-sm-12 ">
                  <button
                    type="submit"
                    className="btn "
                    style={{
                      borderRadius: "25px",
                      float: "right",
                      fontWeight: "900",
                      background: "#047104",
                      color: "#fff",
                    }}
                  >
                    Changer mot de passe
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
}
